import { createSlice } from '@reduxjs/toolkit'
import { CONNECTION_STATUS } from '@common'

const initialState = {
    status: CONNECTION_STATUS.DISCONNECTED,
    error: null,
    activeGroupId: null, // cash register id used as group identifier
}

export const pubsubSlice = createSlice({
    name: 'pubsub',
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload
            if (action.payload !== CONNECTION_STATUS.ERROR) state.error = null
        },
        setError: (state, action) => {
            state.status = CONNECTION_STATUS.ERROR
            state.error = action.payload
        },
        setActiveGroupId: (state, action) => {
            state.activeGroupId = action.payload
        },
        clearActiveGroupId: state => {
            state.activeGroupId = null
        },
    },
})

export const pubsubActions = {
    ...pubsubSlice.actions,
}

export default pubsubSlice.reducer
